import { render } from "./family-info.vue?vue&type=template&id=634ad617&scoped=true"
import script from "./family-info.vue?vue&type=script&lang=js"
export * from "./family-info.vue?vue&type=script&lang=js"

import "./family-info.vue?vue&type=style&index=0&id=634ad617&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-634ad617"]])

export default __exports__